/**
 * Sync API Service
 * Handles manual sync triggers and sync log retrieval
 */

import { api } from './api';
import type {
  TriggerSyncResponse,
  SyncLogsResponse,
  RecreateSubscriptionsResponse,
  SubscriptionsListResponse,
} from '../types/api';

export const syncApi = {
  /**
   * Trigger manual sync for all subscribed scenarios in a project
   */
  triggerProjectSync: async (projectId: string, options?: { force?: boolean }): Promise<TriggerSyncResponse> => {
    return api.post<TriggerSyncResponse>(`/admin/projects/${projectId}/sync`, options);
  },

  /**
   * Get sync activity logs for a project (newest first)
   */
  getSyncLogs: async (projectId: string, limit = 20): Promise<SyncLogsResponse> => {
    const params = new URLSearchParams({ limit: String(limit) });
    return api.get<SyncLogsResponse>(`/admin/projects/${projectId}/sync-logs?${params}`);
  },

  /**
   * List Graph webhook subscriptions for a project with derived health.
   * Read-only — client_state is redacted server-side.
   */
  getSubscriptions: async (projectId: string): Promise<SubscriptionsListResponse> => {
    return api.get<SubscriptionsListResponse>(`/admin/projects/${projectId}/subscriptions`);
  },

  /**
   * Recreate Graph API webhook subscriptions for a project.
   * Deletes all existing subscriptions and creates fresh ones.
   */
  recreateSubscriptions: async (projectId: string, options?: { force_new?: boolean }): Promise<RecreateSubscriptionsResponse> => {
    return api.post<RecreateSubscriptionsResponse>(`/admin/projects/${projectId}/subscriptions/recreate`, options);
  },
};
